/**
 *
 * AddMember
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  accentColorPrim,
  fontColorPrim,
  fontColorSecond,
} from '../../../../assets/styledAssets/vars';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import {
  Column,
  Row,
  StyledTable,
  Wrap,
} from '../../../../assets/styledAssets/grid';
import { StyledFormField } from '../../../../components/FormField/styles';
import { Input } from '@progress/kendo-react-inputs';
import { SearchIcon } from '../../../../components/Icons/Icons.component';
import Button from '../../../../components/Button/Button.component';
import { GridColumn } from '@progress/kendo-react-grid';
import { fetchListMembers } from '../../../../service/Space.service';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../app/store';
import { SpaceMember } from '../../../Spaces/spaces';
import { User } from '../../../../domains/app';
import DialogWrap from '../../../../components/DiaogWrap/DiaogWrap.component';
import InviteMember from '../../../../components/InviteMember/InviteMember.component';
import SpaceService from '../../../../service/Space.service';

const connector = connect(
  (state: RootState) => ({
    selectedAccount: state.app.selectedAccount,
    profile: state.app.user,
  }),
  {},
);

interface IProps {
  onCancel: () => void;
  onSave: (m: SpaceMember[]) => void;
  addedMembers: User[];
}

type PropsFromRedux = ConnectedProps<typeof connector>;

const AddMember: FunctionComponent<IProps & PropsFromRedux> = ({
  onCancel,
  onSave,
  selectedAccount,
  addedMembers,
  profile,
}) => {
  const intl = useIntl();
  const [listMembers, setListMembers] = useState<SpaceMember[]>([]);
  const [filteredMembers, setFilteresMembers] = useState<SpaceMember[]>([]);
  const [showInvite, setShowInvite] = useState<boolean>(false);

  useEffect(() => {
    fetchListMembers(selectedAccount?.id as string, 1000, 0).then((res) => {
      const addedIds = addedMembers.map((m) => m.id);
      const notAddedMembers = res.items.filter(
        (m) => !addedIds.includes(m.personId),
      );
      setListMembers(notAddedMembers);
      setFilteresMembers(notAddedMembers);
    });
    // eslint-disable-next-line
  }, []);

  const updateField = (dataItem: any, field: keyof User) => {
    const index = filteredMembers.findIndex((m) => m.id === dataItem.id);
    let newMembers = [...filteredMembers];
    newMembers[index] = {
      ...newMembers[index],
      [field]: !dataItem[field],
    };
    setFilteresMembers(newMembers);
  };

  const filterUsers = (val: string) => {
    setFilteresMembers(
      listMembers.filter((m) => {
        return (
          (m.person.firstName || '').includes(val) ||
          (m.person.lastName || '').includes(val) ||
          (m.person.email || '').includes(val)
        );
      }),
    );
  };

  const inviteMember = (email: string) => {
    SpaceService.inviteMember(
      selectedAccount?.id as string,
      profile?.id as string,
      email,
    ).finally(() => setShowInvite(false));
  };

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Column xs={100}>
            <Wrap alignItems={'center'} justifyCont={'space-between'}>
              <Wrap fs={'2.4rem'} color={accentColorPrim}>
                {intl.formatMessage(messages.title)}
              </Wrap>
              <Button primary onClick={() => setShowInvite(true)}>
                {intl.formatMessage(messages.invite)}
              </Button>
            </Wrap>
          </Column>
        </Row>
        <Row>
          <Wrap margin={'3rem 0'} width={'100%'}>
            <Column xs={100}>
              <StyledFormField grey>
                <Input onChange={(e) => filterUsers(e.value)} />
                <SearchIcon color={fontColorPrim} width={'2rem'} />
              </StyledFormField>
            </Column>
          </Wrap>
          <Column xs={100}>
            <Wrap grow={'1'} overflow={'hidden'} width={'100%'} height={'100%'}>
              <StyledTable
                selectedField="checked"
                data={filteredMembers}
                onSelectionChange={(e) => updateField(e.dataItem, 'checked')}
              >
                <GridColumn
                  field={'checked'}
                  width="50px"
                  headerCell={() => <div />}
                />
                <GridColumn
                  field="firstName"
                  title={intl.formatMessage(messages.spaceMembers)}
                  cell={(props) => (
                    <td onClick={() => updateField(props.dataItem, 'checked')}>
                      <Wrap>
                        {props.dataItem.person.firstName}{' '}
                        {props.dataItem.person.lastName}
                      </Wrap>
                      <Wrap color={fontColorSecond}>
                        {props.dataItem.person.email}
                      </Wrap>
                    </td>
                  )}
                />
              </StyledTable>
            </Wrap>
          </Column>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>

        <StyledModalAction
            accent
          onClick={() => onSave(filteredMembers.filter((m) => m.checked))}
        >
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
      {showInvite && (
        <DialogWrap
            title={intl.formatMessage(messages.inviteMember)}
          children={
            <InviteMember
              onCancel={() => setShowInvite(false)}
              onSave={inviteMember}
            />
          }
        />
      )}
    </>
  );
};

export default connector(memo(AddMember));
